import { takeLatest, put, call } from 'redux-saga/effects';

import { filterNFeEmissao } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_NFE_EMISSAO,
  NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_PENDING,
  NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_NFE_EMISSAO } from '@commons/consts';

function* sagaNewFilterNextPageNFeEmissao(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_PENDING });

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_NFE_EMISSAO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_NFE_EMISSAO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    const list = yield call(filterNFeEmissao, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);

    sessionStorage.setItem(CONST_FILTER_NFE_EMISSAO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_NFE_EMISSAO_FAILURE })
  }
}

export default function* watchNewFilterNextPageNFeEmissao() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_NFE_EMISSAO, sagaNewFilterNextPageNFeEmissao)
}